module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray-a383e8fa94685f46b712cea6dd400bf9.png";